import { Heading, type HeadingProps } from '@radix-ui/themes';
import { cn } from '@/lib/utils';

type HeaderItalicProps = Omit<HeadingProps, 'color' | 'weight'> & {
  color?: 'white' | HeadingProps['color'];
};

/** v90 Playfair italic screen title — one per view, Radix size 6 / medium. */
export function HeaderItalic({
  color = 'white',
  size = '6',
  className,
  style,
  ...props
}: HeaderItalicProps) {
  const isWhite = color === 'white';
  return (
    <Heading
      size={size}
      weight="medium"
      color={isWhite ? undefined : color}
      className={cn('header-italic', isWhite && 'text-white', className)}
      style={style}
      {...props}
    />
  );
}

export type { HeaderItalicProps };
